/**
 * BHV-icoon/chip (Epic 4, Story 4.2, AC 5) — oorspronkelijk alleen-
 * weergave, geen dekkingssignaal (besluit Friso, FR-11).
 *
 * ⚠ KOERSWIJZIGING (Epic ux-aanwezigheidscel-duur, Story 1.3, CAP-4,
 * Open Decision 1): FR-11 is VERVANGEN, niet vervallen. Op expliciete,
 * nieuwere instructie van Friso in de ux-aanwezigheidscel-duur-sessie
 * ("chip alleen bij wie nú werkt en BHV'er is; niet bij vrij/ziek") +
 * de vastgelegde UX-spec is het BHV-teken vanaf Story 1.3 wél een
 * dekkingssignaal geworden: het rij-niveau `BhvBadge` hieronder (altijd
 * zichtbaar naast de naam, ongeacht status) is VERWIJDERD uit
 * `AanwezigheidGrid.tsx` en vervangen door het cel-niveau `EhboBadge`
 * (zie hieronder), dat alléén verschijnt wanneer die persoon dat
 * dagdeel daadwerkelijk werkt (`AanwezigheidCell.tsx`). Deze component
 * (`BhvBadge`) zelf wordt nergens meer gebruikt na Story 1.3, maar
 * blijft geëxporteerd als historische referentie/rollback-pad — geen
 * dead-code-verwijdering zonder expliciet verzoek.
 */
export function BhvBadge() {
  return (
    <span
      data-testid="bhv-badge"
      title="BHV"
      aria-label="BHV"
      className="inline-flex items-center justify-center w-4 h-4 rounded-sm bg-[#2F5A7A] text-white text-[9px] font-bold flex-shrink-0"
    >
      B
    </span>
  );
}

/**
 * EHBO-teken — cel-niveau BHV-DEKKINGSsignaal (Epic ux-aanwezigheidscel-
 * duur, Story 1.3, CAP-4). Renderconditie is bewust NIET hier maar bij de
 * caller (`AanwezigheidCell.tsx`'s `HalfCell`, `werkt`-tak): dit
 * component tekent onvoorwaardelijk het rood-wit EHBO-symbool zodra het
 * gemount wordt — "verschijnt alléén wanneer de persoon dat dagdeel
 * daadwerkelijk werkt" is de aanroeper's verantwoordelijkheid, niet de
 * component's.
 *
 * Palet-uitzondering (expliciet besluit Friso, UX-spec): `#D64545` (rood)
 * is normaal uitsluitend voor echte fouten gereserveerd; het klassieke
 * rood-wit EHBO-symbool is de ENIGE toegestane uitzondering op dit
 * scherm — nergens anders (ook niet in de Story 1.2 ziek-herstyling).
 *
 * Epic aanwezigheidscel-iteratie2, Story 1.3 (CAP-6, AC 7/8): verkleind
 * van 16px (`w-4 h-4`) naar ~12px (`w-3 h-3`), wit kruis navenant kleiner
 * meeschalend (`h-2.5 w-2.5` → `h-2 w-2`) — zodat het teken rechtsboven
 * vrij blijft van het gecentreerde "Kantoor"/"Thuis"-label in de smalle
 * cel (zie `AanwezigheidCell.tijdBadgeSplit`/`werkt`-tak). Renderconditie,
 * rode achtergrond, aria-label en positionering blijven ongewijzigd.
 */
export function EhboBadge({ className = '' }: { className?: string }) {
  return (
    <span
      data-testid="ehbo-badge"
      title="BHV'er aanwezig"
      aria-label="BHV'er aanwezig"
      className={`absolute top-0.5 right-0.5 inline-flex items-center justify-center w-3 h-3 rounded-sm ${className}`}
      style={{ backgroundColor: '#D64545' }}
    >
      <svg aria-hidden="true" className="h-2 w-2" fill="none" stroke="white" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
      </svg>
    </span>
  );
}
